import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-x-circle', 'LetterXCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9 8l6 8m-6 0 6-8","key":"svg-0"}]]);